import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { HeaderUserItem } from "codekit";

import { getCargoPreview, getIsAdmin, setVercomoAbierto } from "../../../libs/redux/slices/authSlice/authSlice";

/**
 * "Ver como cargo" (Diego 2026-09-14): ítem del menú del usuario, solo para
 * administradores, que abre la ventana de elección de cargo (la ventana y la
 * franja viven en Vercomob, fuera del menú, para que no se desmonten al cerrarlo).
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 */
const Vercomo = () => {
  const dispatch = useDispatch();
  const isAdmin = useSelector(getIsAdmin);
  const cargoPreview = useSelector(getCargoPreview);
  if (!isAdmin) {
    return null;
  }
  return (
    <HeaderUserItem icon="user-change" onClick={() => dispatch(setVercomoAbierto(true))}>
      {cargoPreview ? `${cargoPreview.ACTUAR ? "Actuando como" : "Viendo como"}: ${cargoPreview.CARDESXX}` : "Ver o actuar como cargo"}
    </HeaderUserItem>
  );
};

export default Vercomo;
